document.addEventListener('DOMContentLoaded', () => {

    /* =========================
       TEAM FILTERS
    ========================= */

    const filterButtons = document.querySelectorAll('.mtt-filters button');
    const teamMembers = document.querySelectorAll('.team-member');
    const teamGrid = document.querySelector('.mtt-bottom');

    function updateTeamGridForFiveMembers() {

        if (!teamGrid) {
            return;
        }

        const isDesktop = window.innerWidth > 992;
        const visibleMembers = Array.from(teamMembers).filter(member => {
            return window.getComputedStyle(member).display !== 'none';
        });

        const rebalanceCounts = [5, 9];

        if (isDesktop && rebalanceCounts.includes(visibleMembers.length)) {
            teamGrid.style.gridTemplateColumns = 'repeat(3, minmax(0, 1fr))';
            return;
        }

        teamGrid.style.gridTemplateColumns = '';

    }

    updateTeamGridForFiveMembers();

    window.addEventListener('resize', updateTeamGridForFiveMembers);

    filterButtons.forEach(button => {

        button.addEventListener('click', () => {

            filterButtons.forEach(btn => {
                btn.classList.remove('active');
            });

            button.classList.add('active');

            const filter = button.dataset.filter;

            teamMembers.forEach(member => {

                if (filter === 'all') {
                    member.style.display = '';
                    return;
                }

                if (member.classList.contains(filter)) {
                    member.style.display = '';
                } else {
                    member.style.display = 'none';
                }

            });

            updateTeamGridForFiveMembers();

        });

    });


    /* =========================
       TEAM MEMBER MODAL
    ========================= */

    const modal = document.getElementById('team-modal');
    const modalMembers = document.querySelectorAll('.js-team-member');

    if (!modal || !modalMembers.length) {
        return;
    }

    const modalImage = document.getElementById('team-modal-img');
    const modalName = document.getElementById('team-modal-name');
    const modalTitle = document.getElementById('team-modal-title');
    const modalBio = document.getElementById('team-modal-bio');

    const closeButton = modal.querySelector('.team-modal-close');
    const overlay = modal.querySelector('.team-modal-overlay');


    /* Open modal */

    function openModal(member) {

        modalName.textContent = member.dataset.name || '';
        modalTitle.textContent = member.dataset.title || '';
        modalBio.textContent = member.dataset.bio || '';

        modalImage.src = member.dataset.image || '';
        modalImage.alt = member.dataset.imageAlt || member.dataset.name || '';

        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');

        document.body.classList.add('team-modal-open');

    }


    /* Close modal */

    function closeModal() {

        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');

        document.body.classList.remove('team-modal-open');

    }


    /* Click team member */

    modalMembers.forEach(member => {

        member.addEventListener('click', () => {
            openModal(member);
        });

    });


    /* Close button */

    if (closeButton) {
        closeButton.addEventListener('click', closeModal);
    }


    /* Click overlay */

    if (overlay) {
        overlay.addEventListener('click', closeModal);
    }


    /* Escape key */

    document.addEventListener('keydown', event => {

        if (
            event.key === 'Escape' &&
            modal.classList.contains('is-open')
        ) {
            closeModal();
        }

    });

});